export default {
  "isMiniApp": false,
  "environment": "production",
  "cookieDomain": ".magazineluiza.com.br",
  "datasource": {
    "graphql": {
      "host": "https://federation.magazineluiza.com.br",
      "timeout": 5000
    }
  },
  "datadog": {
    "dataDogEnable": true,
    "dataDogEnv": "production",
    "dataDogSessionRate": 10,
    "dataDogSessionReplay": 1
  },
  "google": {
    "clientId": "501289460576-mtgfaaa1gpp6tbt0q17k7pbkm25j9hs0.apps.googleusercontent.com"
  },
  "sac": {
    "baseUrl": "https://atendimento.magazineluiza.com.br"
  },
  "magaluPay": {
    "moreInfoUrl": "https://especiais.magazineluiza.com.br/magalupay/",
    "termsOfUseUrl": "https://especiais.magazineluiza.com.br/termos-de-uso-para-magalupay/"
  },
  "nationalUrls": {
    "mobile": "https://sacolamobile.magazineluiza.com.br",
    "desktop": "https://sacola.magazineluiza.com.br"
  },
  "platform": {
    "desktop": {
      "baseUrl": "https://www.magazineluiza.com.br",
      "cart": {
        "host": "https://sacola.magazineluiza.com.br"
      }
    },
    "mobile": {
      "baseUrl": "https://m.magazineluiza.com.br",
      "cart": {
        "host": "https://sacolamobile.magazineluiza.com.br"
      }
    }
  },
  "allowedDomainsForNext": {
    "domains": [
      ".magazineluiza.com.br",
      ".magazinevoce.com.br",
      ".influenciadormagalu.com.br"
    ]
  },
  "captcha": {
    "siteKey": "6LdZgd8nAAAAACORQAbrn5mzgAXTgwTmp3pSjPKe"
  }
}
